import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=ffb185fc&scoped=true"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=ffb185fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb185fc",
  null
  
)

export default component.exports